export default {
    find:   { method: 'get',    url: 'course_campus_infos' },
    create: { method: 'post',   url: 'course_campus_infos'},
    update: { method: 'put',    url: 'course_campus_infos/{id}'},
    delete: { method: 'delete', url: 'course_campus_infos/{id}'},
}